
export class EmployeeClass {
  id: number;
  name: string;
  description: string;
  orgId: number;
  version: number;
  scaEmployeeClass: boolean = false;
  allowWeekendCharging: boolean;
  allowHolidayCharging: boolean;
}
